import {Values} from '@wix/devzai-utils-common';

export const DoppeActionListItemClickBehaviour = {
    PreviewItem: 'PreviewItem',
    OpenLink: 'OpenLink',
    PreviewItemAsPopup: 'PreviewItemAsPopup',
} as const;

export type DoppeActionListItemClickBehaviour = Values<typeof DoppeActionListItemClickBehaviour>;
